import { createClient } from "@supabase/supabase-js";

// Wir sagen TypeScript explizit, dass dies Strings sind.
// Falls sie fehlen, würde createClient meckern, aber so ist es sauberer.
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error("FATAL: Supabase URL oder Key fehlt in der .env Datei!");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
